/**
 * Decorative backdrop for the dashboard: soft aurora color blobs behind the
 * hero (logo + search) and a faint dot grid fading downwards. Purely visual —
 * absolutely positioned and non-interactive.
 */
export const DashboardBackdrop = () => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-0 overflow-hidden"
  >
    <div className="absolute top-[2%] left-1/2 h-[52%] w-[70%] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgb(var(--gradient-wash-rgb)/0.3),transparent)] blur-3xl" />
    <div className="absolute top-[22%] left-[2%] h-[46%] w-[34%] rounded-full bg-[radial-gradient(closest-side,rgba(255,170,96,0.28),transparent)] blur-3xl" />
    <div className="absolute top-[26%] right-[0%] h-[48%] w-[36%] rounded-full bg-[radial-gradient(closest-side,rgba(96,210,160,0.26),transparent)] blur-3xl" />
    <div className="absolute bottom-[-10%] left-[20%] h-[38%] w-[44%] rounded-full bg-[radial-gradient(closest-side,rgb(var(--gradient-wash-rgb)/0.12),transparent)] blur-3xl" />

    <div className="absolute inset-0 [background-image:radial-gradient(hsl(220_20%_12%/0.08)_1px,transparent_1px)] [background-size:22px_22px] [mask-image:radial-gradient(ellipse_60%_45%_at_50%_38%,black,transparent)]" />
  </div>
)
